package com.eladfinish.bible.contest.analytics

import com.eladfinish.bible.contest.analytics.AnalyticsConstants.UserProperty
import com.eladfinish.bible.contest.platform.isAndroid
import com.eladfinish.bible.contest.platform.isIos
import com.eladfinish.bible.contest.repository.analytics.FirebaseAnalyticsRepository
import com.eladfinish.bible.contest.screens.search.analytics.AnonymousInstallationIdProvider
import com.russhwolf.settings.Settings

/**
 * Sets the anonymous installation id, the one the search events already carry, as the Firebase
 * user property [UserProperty.INSTALLATION_ID], so a heavy searcher can be found in Firebase and
 * in the search table by the same key. It is a random id and the only identifier added; it is
 * set while anonymous usage statistics are on and cleared when they are off (the Firebase data
 * source stores a null as an empty value), at launch and when the setting is toggled. Like every event.
 * Only Android and iOS report to Firebase Analytics.
 */
class InstallationIdUserProperty(
    private val settings: Settings,
    private val installationIdProvider: AnonymousInstallationIdProvider,
    private val firebaseAnalyticsRepository: FirebaseAnalyticsRepository,
    private val reportsToFirebase: Boolean = isAndroid || isIos,
) {
    operator fun invoke() {
        if (!reportsToFirebase) return
        // Consent first: asking the provider for the id creates and stores one.
        val id = if (settings.usageStatsEnabled()) installationIdProvider.getAnonymousInstallationId() else null
        firebaseAnalyticsRepository.setUserProperty(UserProperty.INSTALLATION_ID, id)
    }
}
